var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart"},[_c('apexchart',{attrs:{"type":"bar","options":_vm.options,"series":_vm.series,"height":"500","width":"1000"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }